import React from 'react'
import {FormattedMessage} from 'react-intl';

export const PRODUCT_GROUP_TYPES = {
  SIMPLE_SIGNATURE: 'simple-signatures',
  QUALIFIED_SIGNATURE: 'qualified-signatures',
  CERTIFICATE: 'certificates',
  ELECTRONIC_ARCHIVING_SERVICE: 'electronic-archiving-service',
  ADDITIONAL_STORAGE_ELECTRONIC_ARCHIVING: 'additional-storage-electronic-archiving',
  ADDITIONAL_DOWNLOADING_DOCUMENTS: 'additional-downloading-documents',
  CERTIFICATE_WITH_AUTH: 'certificates-with-auth',
}

export const TRANSLATED_PRODUCT_GROUP_TYPES = {
  [PRODUCT_GROUP_TYPES.SIMPLE_SIGNATURE] : <FormattedMessage id="product_group.simple_signature" />,
  [PRODUCT_GROUP_TYPES.QUALIFIED_SIGNATURE] : <FormattedMessage id="product_group.qualified_signature" />,
  [PRODUCT_GROUP_TYPES.CERTIFICATE] : <FormattedMessage id="product_group.certificate" />,
  [PRODUCT_GROUP_TYPES.ELECTRONIC_ARCHIVING_SERVICE] : <FormattedMessage id="product_group.electronic_archiving_service" />,
  [PRODUCT_GROUP_TYPES.ADDITIONAL_STORAGE_ELECTRONIC_ARCHIVING] : <FormattedMessage id="product_group.additional_storage_electronic_archiving" />,
  [PRODUCT_GROUP_TYPES.ADDITIONAL_DOWNLOADING_DOCUMENTS] : <FormattedMessage id="product_group.additional_downloading_documents" />,
  [PRODUCT_GROUP_TYPES.CERTIFICATE_WITH_AUTH] : <FormattedMessage id="product_group.certificate_with_auth" />,
}

export const COLORS_PRODUCT_GROUP_TYPES = {
  [PRODUCT_GROUP_TYPES.SIMPLE_SIGNATURE] : '#ffd600',
  [PRODUCT_GROUP_TYPES.QUALIFIED_SIGNATURE] : '#fb6340',
  [PRODUCT_GROUP_TYPES.CERTIFICATE] : '#f5365c',
  [PRODUCT_GROUP_TYPES.ELECTRONIC_ARCHIVING_SERVICE] : '#5e72e4',
  [PRODUCT_GROUP_TYPES.ADDITIONAL_STORAGE_ELECTRONIC_ARCHIVING] : '#8965e0',
  [PRODUCT_GROUP_TYPES.ADDITIONAL_DOWNLOADING_DOCUMENTS] : '#2dce89',
  [PRODUCT_GROUP_TYPES.CERTIFICATE_WITH_AUTH] : '#11cdef',
}

export const ARCHIVE_PRODUCT_GROUPS = [
  PRODUCT_GROUP_TYPES.ADDITIONAL_STORAGE_ELECTRONIC_ARCHIVING,
  PRODUCT_GROUP_TYPES.ADDITIONAL_DOWNLOADING_DOCUMENTS,
  PRODUCT_GROUP_TYPES.ELECTRONIC_ARCHIVING_SERVICE,
];

export const IGNORED_PRODUCT_GROUPS_FOR_CAMPAIGN = [
  PRODUCT_GROUP_TYPES.ADDITIONAL_STORAGE_ELECTRONIC_ARCHIVING,
  PRODUCT_GROUP_TYPES.ADDITIONAL_DOWNLOADING_DOCUMENTS
];

